/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import template from './views/student-list.html';
import controller from './controllers/controller';
var module = angular.module('myCumulativeReport', [
    //import modules
]).controller('myCumulativeReport', controller);

module.constant('myCumulativeReport', {
})



// WEBPACK FOOTER //
// ./src/app/educore_reports/cumulative/module.js